<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<div class="resources">
  <div class="title" [style.height.px]="heightTitle()">
    @if (resourceTitle()) {
      <span>{{ resourceTitle() | translate }}</span>
    }
  </div>
  @for (group of resources(); track group.id) {
    <div class="row-header">
      <div class="header-title" (click)="collapse(group)">
        <div class="label">{{ group.label }}</div>
        <span class="collapse-arrow">
          <span
            class="fal fa-{{
              group.isOpened ? 'chevron-down' : 'chevron-right'
            }}"
          ></span>
        </span>
      </div>
      @if (group.isOpened) {
        @for (element of group.tasksGroups; track element.id) {
          <div
            #resourceRow
            class="item"
            [style.height.px]="element.height"
            [style.background-color]="element.backgroundColor"
            (mouseenter)="onHover(element)"
            (mouseleave)="onHover(element, false)"
          >
            <span class="label">
              {{ element.label }}
            </span>
          </div>
        }
      }
    </div>
  }
</div>
